import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Backimg from "../../assets/img/skip-arrow.svg";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../context/auth/AuthContext";
import ProcessPassedModal from "../../pages/onboarding/ProcessPassedModal";
import { trackClarityEvent } from "../../Utils/clarityReady";
import constants from "../../Utils/constants";

const FreeTextModal = ({
  user,
  showFreeTextPopup,
  setShowFreeTextPopup,
  updateTenantData,
  loadFullInfo,
  isPopup,
  originalUser,
  isDummySignup,
  setStep,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { loadUserTenant, setLoading } = useContext(AuthContext);
  const [aboutMe, setAboutMe] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [doItLaterLoading, setDoItLaterLoading] = useState(false);
  const [showTickScreen, setShowTickScreen] = useState(false);
  const isConsentEnabled = true;

  useEffect(() => {
    setAboutMe(user?.about_me ?? "");
  }, [user]);

  const handleSubmitHandler = async () => {
    try {
      let payload = {
        about_me: aboutMe,
        role: localStorage.getItem("usertype"),
      };

      if (isConsentEnabled) {
        payload.step = 9;
      } else if (!isPopup) {
        payload.is_edit = false;
        payload.profile_completed = true;
      }
      setSubmitLoading(true);
      await updateTenantData(payload);
      if (isPopup) {
        await loadFullInfo(false);
        setShowFreeTextPopup(false);
      } else {
        // navigate(
        //   `/home${
        //     originalUser?.gurantor_added_id?.length === 0 ? "?welcome=true" : ""
        //   }`
        // );
        trackClarityEvent("tenant_context_step_ended");
        setTimeout(() => {
          trackClarityEvent("tenant_onboarding_ended");
        }, constants.CLARITY_DELAY);
      }
    } catch (error) {
      console.log("Error submitting reason", error);
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleDoItLater = async () => {
    if (doItLaterLoading) {
      return;
    }
    // In dummy mode, just navigate without any API call
    if (isDummySignup) {
      sessionStorage.removeItem("dummy_email");
      sessionStorage.removeItem("isDummySignup");
      navigate(`/demo/home`);
      return;
    }
    if (!isConsentEnabled) {
      setLoading(true);
    }

    let formData = {
      role: localStorage.getItem("usertype"),
    };
    if (isConsentEnabled) {
      formData.step = 9;
    } else {
      formData.profile_completed = true;
      formData.is_edit = false;
      formData.lang = localStorage.getItem("i18nextLng");
    }

    try {
      setDoItLaterLoading(true);
      await updateTenantData(formData);
      await loadUserTenant("tenant");

      navigate(
        `/home${
          originalUser?.gurantor_added_id?.length === 0 ? "?welcome=true" : ""
        }`
      );
      trackClarityEvent("tenant_onboarding_ended");
      setTimeout(() => {
        trackClarityEvent("tenant_profile_info_completed");
      }, constants.CLARITY_DELAY);
    } catch (err) {
    } finally {
      if (!isConsentEnabled) {
        setLoading(false);
      }
      setDoItLaterLoading(false);
    }
  };

  return (
    <>
      <Modal
        show={showFreeTextPopup}
        onHide={() => (isPopup ? setShowFreeTextPopup(false) : {})}
        centered
        className={`newmodalui asguarantor wrapper-modal addContextModal ${
          !isPopup ? "modal-fixed-screen" : ""
        }`}
      >
        <Modal.Header>
          <Modal.Title>
            <div className="wrapperHeading">
              <div className="wrapperHeadingInner">
                <h2 className="addContextHeading">
                  {_t("addContextToYourApplication")}
                </h2>
                {!isPopup && (
                  <div>
                    <div
                      className="skipbtn cursor-pointer skipButtonDesktop greenHover willDoLeterButton"
                      onClick={handleDoItLater}
                    >
                      <p>
                        {_t(
                          "iWillDoItLater",
                          "Text used in guarantor screen at onboarding flow"
                        )}
                      </p>
                      <img src={Backimg} alt="icon" className="canceicon" />
                    </div>
                  </div>
                )}
                <span className="addContextSubheading">
                  {_t("thisInformationHelpsUsReviewYourCaseFaster")}
                </span>
              </div>
              {!isPopup && (
                <div
                  className="skipbtn cursor-pointer skipButtonMobile greenHover"
                  onClick={handleDoItLater}
                >
                  <p>
                    {_t(
                      "skip",
                      "Text used in guarantor screen at onboarding flow"
                    )}
                  </p>
                  <img src={Backimg} alt="icon" className="canceicon" />
                </div>
              )}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (isPopup || isConsentEnabled) {
                handleSubmitHandler();
              } else {
                setShowTickScreen(true);
              }
            }}
          >
            <textarea
              className="modal-textarea-div"
              type="text"
              placeholder={_t(
                "theMoreContextYouGiveUsTheFasterWeCanProcessYourApplication"
              )}
              maxLength={500}
              value={aboutMe}
              onChange={(e) => setAboutMe(e.target.value)}
            ></textarea>
            <div className="charLength">{aboutMe?.length}/500</div>
            <div className="d-flex align-items-center justify-content-center custom-mt-4 custom-gap-2">
              {isPopup && (
                <button
                  className="btnNext basicInfoButton greenHover cancelButton"
                  onClick={() => setShowFreeTextPopup(false)}
                >
                  {_t("cancel")}
                </button>
              )}
              <button
                className="btnNext basicInfoButton greenHover"
                disabled={submitLoading}
              >
                {isPopup ? _t("save") : _t("continue")}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <ProcessPassedModal
        heading={_t("onboardingSuccessful")}
        subheading={_t("yourOnboardingHasBeenSuccessfullyCompleted")}
        showPopup={showTickScreen}
        buttonText={"goHome"}
        handleClick={handleSubmitHandler}
      />
    </>
  );
};

export default FreeTextModal;
